<template>
  <b-modal id="changepassword-modal" ref="modal" title="Zmiana hasła" @hidden="onClose">
    <p>
      Zmień hasło do konta
      <b>{{user.email}}</b>:
    </p>
    <ValidationObserver
      ref="changepassowrdForm"
      tag="form"
      @submit.prevent="onSubmit"
      
      id="changepassowrdForm"
    >
      <div class="form-group row">
        <label for="password" class="col-lg-4 col-form-label text-right">Nowe hasło:</label>
        <div class="col-lg-8">
          <ValidationProvider
            name="password"
            rules="required|min:8|password:@password_confirmation"
            v-slot="validationContext"
            mode="lazy"
          >
            <b-form-input
              id="password"
              v-model="form.password"
              type="password"
              :state="getValidationState(validationContext)"
            ></b-form-input>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </ValidationProvider>
        </div>
      </div>
      <div class="form-group row">
        <label for="password_confirmation" class="col-lg-4 col-form-label text-right">Potwierdź hasło:</label>
        <div class="col-lg-8">
          <ValidationProvider
            name="password_confirmation"
            rules="required|min:8"
            v-slot="validationContext"
            mode="lazy"
          >
            <b-form-input
              id="password_confirmation"
              v-model="form.password_confirmation"
              type="password"
              :state="getValidationState(validationContext)"
            ></b-form-input>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </ValidationProvider>
        </div>
      </div>
    </ValidationObserver>
    <template v-slot:modal-footer="{cancel}">
      <b-button size="md" variant="primary" type="submit" form="changepassowrdForm">Zapisz</b-button>
      <b-button size="md" variant="outline-danger" @click="cancel()">Anuluj</b-button>
    </template>
  </b-modal>
</template>

<script>
import userManager from "@/services/userManager.service";

export default {
  name: "ModalUserChangePassword",
  props: {
    user: Object,
    prefix: { type: String, default: undefined }
  },
  data() {
    return {
      form: {
        password: "",
        password_confirmation: ""
      }
    };
  },
  methods: {
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onClose() {
      this.form.password = "";
      this.form.password_confirmation = "";
      this.$emit("onClose");
    },
    onSubmit() {
      this.$refs.changepassowrdForm.validate().then(success => {
        if (!success) {
          return;
        }
        this.$Progress.start();
        userManager
          .ChangePassword(this.user.id, this.form, this.prefix)
          .then(() => {
            this.$bvModal.hide("changepassword-modal");
          })
          .catch(error => {
            this.$refs.changepassowrdForm.setErrors(error.response.data.fields);
          });
      });
    }
  }
};
</script>